import { render, staticRenderFns } from "./KimsaTextField.vue?vue&type=template&id=b746b86e&scoped=true&"
import script from "./KimsaTextField.vue?vue&type=script&lang=js&"
export * from "./KimsaTextField.vue?vue&type=script&lang=js&"
import style0 from "./KimsaTextField.vue?vue&type=style&index=0&id=b746b86e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b746b86e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
